import React from "react";
import { Layout, Typography, Collapse } from "antd";
import { useLanguage } from "../../context/LanguageContext";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { Panel } = Collapse;

const AGBs = () => {
  const { language } = useLanguage();

  const termsDe = [
    {
      title: "1. Geltungsbereich",
      content:
        'Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge über die Nutzung der SaaS-Lösungen der [Firmenname] (nachfolgend "Anbieter") zwischen dem Anbieter und seinen Kunden (nachfolgend "Kunde").',
    },
    {
      title: "2. Vertragsgegenstand",
      content:
        "Gegenstand des Vertrages ist die Bereitstellung der Software über ein Abonnement-Modell (monatlich oder jährlich) gemäß dem gewählten Tarif. Details zu Leistungen und Preisen ergeben sich aus dem jeweiligen Bestellschein.",
    },
    {
      title: "3. Leistungsumfang",
      content:
        "Der Anbieter stellt dem Kunden über das Internet Zugang zur ausgewählten SaaS-Anwendung zur Verfügung. Wartung, Updates und Upgrades sind im gebuchten Abonnement enthalten.",
    },
    {
      title: "4. Nutzungsrechte",
      content:
        "Der Anbieter gewährt ein nicht ausschließliches, nicht übertragbares Recht zur Nutzung der Software für die Dauer des Abonnements. Vervielfältigung, Bearbeitung oder Weitergabe an Dritte ist untersagt.",
    },
    {
      title: "5. Pflichten des Kunden",
      content:
        "Der Kunde gewährleistet die erforderlichen technischen Voraussetzungen und schützt seine Zugangsdaten. Bei unberechtigter Nutzung haftet der Kunde.",
    },
    {
      title: "6. Entgelte und Zahlungsbedingungen",
      content:
        "Das Abonnement wird entweder monatlich im Voraus oder jährlich zum Beginn des Vertragsjahres in Rechnung gestellt. Zahlungen sind innerhalb von 14 Tagen fällig. Bei Zahlungsverzug kann der Anbieter den Zugang sperren.",
    },
    {
      title: "7. Vertragslaufzeit und Kündigung",
      content:
        "Die Laufzeit richtet sich nach dem Abonnement: Monatlich mit einer Frist von 14 Tagen zum Monatsende oder jährlich mit einer Frist von 3 Monaten zum Ende der Laufzeit. Das Abonnement verlängert sich automatisch um die gewählte Periode, wenn nicht fristgerecht gekündigt wird.",
    },
    {
      title: "8. Haftung und Verfügbarkeit",
      content:
        "Der Anbieter haftet nur für Vorsatz und grobe Fahrlässigkeit. Für leichte Fahrlässigkeit haftet er nur bei Verletzung wesentlicher Vertragspflichten bis zur Höhe des typischerweise vorhersehbaren Schadens. Eine garantierte Verfügbarkeit wird nicht übernommen; der Anbieter strebt jedoch eine Betriebszeit von 99 % an.",
    },
    {
      title: "9. Gewährleistung",
      content:
        "Der Anbieter gewährleistet, dass die Software im Wesentlichen den vertraglich vereinbarten Funktionen entspricht. Bei wesentlichen Mängeln wird nachgebessert; darüber hinausgehende Gewährleistungsansprüche sind ausgeschlossen.",
    },
    {
      title: "10. Datenschutz",
      content:
        "Der Anbieter verarbeitet personenbezogene Daten gemäß DSGVO und schließt einen Auftragsverarbeitungsvertrag ab. Details sind in der Datenschutzvereinbarung geregelt.",
    },
    {
      title: "11. Vertraulichkeit",
      content:
        "Vertrauliche Informationen beider Parteien sind geheim zu halten und dürfen nur zur Vertragserfüllung verwendet werden.",
    },
    {
      title: "12. Änderungen der AGB",
      content:
        "Der Anbieter kann diese AGB mit Wirkung zum Monatsende ändern, wenn die Änderungen für den Kunden zumutbar sind. Der Kunde wird mindestens 6 Wochen vorher informiert und kann widersprechen.",
    },
    {
      title: "13. Schlussbestimmungen",
      content:
        "Es gilt deutsches Recht. Gerichtsstand ist der Sitz des Anbieters. Sollten einzelne Bestimmungen unwirksam sein, bleibt der Vertrag im Übrigen wirksam.",
    },
  ];

  const termsEn = [
    {
      title: "1. Scope",
      content:
        'These General Terms and Conditions (GTC) apply to all subscription agreements for the SaaS solutions provided by [Company Name] ("Provider") between the Provider and its customers ("Customer").',
    },
    {
      title: "2. Subject Matter",
      content:
        "The Provider offers software under a subscription model (monthly or annual) as specified in the order form. Details on services and pricing are set forth in the order form.",
    },
    {
      title: "3. Service Description",
      content:
        "The Provider grants the Customer access to the selected SaaS application via the Internet. Maintenance, updates, and upgrades are included in the subscription.",
    },
    {
      title: "4. License Grants",
      content:
        "The Provider grants a non-exclusive, non-transferable right to use the software during the subscription term. Reproduction, modification, or distribution to third parties is prohibited.",
    },
    {
      title: "5. Customer Obligations",
      content:
        "The Customer must ensure the required technical environment and protect login credentials. The Customer is liable for unauthorized use.",
    },
    {
      title: "6. Fees and Payment",
      content:
        "Subscription fees are billed monthly in advance or annually at the start of the term. Payments are due within 14 days. The Provider may suspend access in case of late payment.",
    },
    {
      title: "7. Term and Termination",
      content:
        "The subscription term is monthly with 14 days' notice to the end of the month or annual with 3 months' notice to the end of the term. The subscription renews automatically for the same period unless canceled timely.",
    },
    {
      title: "8. Liability and Availability",
      content:
        "The Provider’s liability is limited to intent and gross negligence. For slight negligence, liability is limited to essential contractual obligations and typical foreseeable damages. No uptime guarantee is provided; the Provider aims for 99% availability.",
    },
    {
      title: "9. Warranty",
      content:
        "The Provider warrants that the software will substantially perform according to the agreement. For material defects, the Provider will remedy the defect; all other warranties are excluded.",
    },
    {
      title: "10. Data Protection",
      content:
        "The Provider processes personal data according to applicable data protection laws and will enter into a data processing agreement. Details are in the privacy policy.",
    },
    {
      title: "11. Confidentiality",
      content:
        "Confidential information of both parties must be kept confidential and used solely for performance of the agreement.",
    },
    {
      title: "12. Amendments",
      content:
        "The Provider may amend these GTC effective at the end of the month, provided the changes are reasonable. The Customer will be notified at least 6 weeks in advance and may object.",
    },
    {
      title: "13. Final Provisions",
      content:
        "These GTC are governed by German law. Jurisdiction is at the Provider's registered office. If any provision is invalid, the remainder remains in force.",
    },
  ];

  const terms = language === "de" ? termsDe : termsEn;

  return (
    <Layout className="min-h-screen w-full bg-gray-100">
      <Content className="p-4 w-full md:p-8 mx-auto">
        <div className="bg-white w-full shadow-md rounded-lg p-6 md:p-8">
          <Title level={2} className="text-center mb-6">
            {language === "de"
              ? "Allgemeine Geschäftsbedingungen (AGB)"
              : "General Terms and Conditions (GTC)"}
          </Title>
          <Paragraph className="mb-6">
            {language === "de" ? "Zuletzt aktualisiert:" : "Last updated:"}{" "}
            {new Date().toLocaleDateString()}
          </Paragraph>
          <Collapse defaultActiveKey={["0"]} className="bg-white w-full">
            {terms.map((item, index) => (
              <Panel header={item.title} key={index} className="mb-2">
                <Paragraph>{item.content}</Paragraph>
              </Panel>
            ))}
          </Collapse>
        </div>
      </Content>
    </Layout>
  );
};

export default AGBs;
